import { getNextColor } from "@fluentui/react-charting";
import { arrSortAscByKeyValue, getLastDateUTC } from "../../../Utils/js-common";
import { MetricsDataProps } from "./ProductView.interfaces";

export const getMetricsData = (data: MetricsDataProps[], isTenantMetrics: 0 | 1 = 0) => {
  if (!data || data.length === 0) return {} as any;

  const reduceInitialValue = { data: [] as any[] };
  const metricsData = arrSortAscByKeyValue({
    key: "name",
    data: data.reduce((a, b) => ({ ...a, data: a.data.concat(b.data) }), reduceInitialValue).data
  });

  return {
    chartTitle: "Line Chart",
    lineChartData: data
      .filter((x) => x.isTenantMetrics === String(isTenantMetrics))[0]
      ?.data.map((m) => ({
        legend: m.name,
        data: m.data
          .filter((a: any) => {
            // Filter to only include Monthly aggregation type
            // This handles mixed data responses that contain both Daily and Monthly
            return !a.aggregationType || a.aggregationType.toLowerCase() === "monthly";
          })
          .map((a: any) => ({
            x: getLastDateUTC(a.x.split(" ")[0], Number(a.x.split(" ")[1])),
            y: Number(a.y)
          })),
        color: getNextColor(metricsData.findIndex(({ name }: any) => name === m.name)),
        lineOptions: {
          lineBorderWidth: "4"
        }
      }))
  };
};
